export { default } from './createGenerateClassName';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/styles/esm/createGenerateClassName/index.js
// module id = 423
// module chunks = 2